export default __webpack_public_path__ + "static/Florence_Italy-3546d47e60f87f761dfa2fed31a065c3.jpg";